(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TrustTypes", [], factory);
	else if(typeof exports === 'object')
		exports["TrustTypes"] = factory();
	else
		root["TrustTypes"] = factory();
})(this, function() {
return 